module.exports = __webpack_public_path__ + "img/helbiz-mobile.76dc6217.png";